/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface KeyValueOrder {
  key: string;
  value: string;
  order: number;
}
const KeyValueOrder = {
  create: (initValues?: Partial<KeyValueOrder> | null): KeyValueOrder => {
    const defaults: KeyValueOrder = {
      key: "",
      value: "",
      order: 0,
    };
    const fixedValues: Partial<KeyValueOrder> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default KeyValueOrder;
